import styled from 'styled-components';
import colors from '@service-victoria/component-library/utils/colors';

export const Wrapper = styled.div``;

export const Label = styled.dt`
  font-weight: 600;
  line-height: 24px;
  margin: 0 0 8px;
  color: ${colors.blueGrey};
  display: inline;
`;

export const Value = styled.dd`
  display: inline;
  margin: 0 0 24px;
  color: ${colors.blueGrey};
`;

export const ValueUpperCase = styled.dd`
  display: inline;
  margin: 0 0 24px;
  color: ${colors.blueGrey};
  text-transform: uppercase;
`;

export const ReviewItemWrapper = styled(Wrapper)`
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
`;
